/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var DataChartPieA2Icon16Light = forwardRef('DataChartPieA2Icon16Light', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 16 }, props),
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M7.5 1a.5.5 0 0 0-.5.5v6a.5.5 0 0 0 .5.5h6a.5.5 0 0 0 .5-.5A6.5 6.5 0 0 0 7.5 1ZM8 7V2.023A5.5 5.5 0 0 1 12.977 7H8Z" }),
        React.createElement("path", { d: "M5.683 2.309a.5.5 0 0 0-.33-.944 6.5 6.5 0 1 0 8.272 8.31.5.5 0 0 0-.942-.334 5.5 5.5 0 1 1-7-7.032Z" })));
});
